/* unplugin-vue-components disabled */import script from "./ApplicationRoleCard.vue?vue&type=script&setup=true&lang=js"
export * from "./ApplicationRoleCard.vue?vue&type=script&setup=true&lang=js"

import "./ApplicationRoleCard.vue?vue&type=style&index=0&id=604fdc58&scoped=true&lang=less"

import exportComponent from "/Users/zhangxuan/Documents/Projects/VinesDjango/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-604fdc58"]])

export default __exports__